// Mobile menu nav tabs
const parentLinks = document.querySelectorAll(".sidebar-nav .parent-nav a");

parentLinks.forEach((link) => {
  link.addEventListener("click", (e) => {
    e.preventDefault();

    parentLinks.forEach((link) => {
      link.classList.remove("active");
    });

    e.currentTarget.classList.add("active");

    // Get the index of clicked link
    const index = [
      ...e.currentTarget.parentElement.parentElement.children,
    ].indexOf(e.currentTarget.parentElement);

    const submenus = document.querySelectorAll(".sidebar-nav .sub-menu");

    submenus.forEach((menu, i) => {
      menu.classList.remove("active");
      if (i === index) {
        menu.classList.add("active");
      }
    });
  });
});

// Dropdown menu toggle - on click for accessibility
const parentToggles = document.querySelectorAll(".Header__MainNav .parent button");
const dropdowns = document.querySelectorAll(".Header__MainNav .dropdown");

parentToggles.forEach((toggle) => {
  toggle.addEventListener("click", (e) => {
    e.preventDefault();

    // Close any open dropdowns and toggle clicked one
    dropdowns.forEach((dropdown) => {
      const currentToggle = dropdown.previousElementSibling.querySelector('button');
      if (dropdown !== e.currentTarget.parentElement.nextElementSibling) {
        dropdown.classList.remove("active");
        currentToggle.setAttribute("aria-expanded", "false");
      } else {
        dropdown.classList.toggle("active");
        // Toggle aria-expanded state
        const isExpanded = dropdown.classList.contains("active");
        currentToggle.setAttribute("aria-expanded", isExpanded);
      }
    });
  });
});

// Update discount box prices when bundle selected
document.querySelectorAll(".bundle-select input").forEach((button) => {
  button.addEventListener("change", (e) => {
    if (
      e.currentTarget.checked &&
      e.currentTarget.hasAttribute("data-bundle")
    ) {
      const isBundle = e.currentTarget.getAttribute("data-bundle");

      if (isBundle == "true") {
        document
          .querySelectorAll(".discount-item .standard")
          .forEach((item) => {
            item.classList.remove("active");
          });

        document
          .querySelectorAll(".discount-item .bundle")
          .forEach((item) => {
            item.classList.add("active");
          });
      } else {
        document
          .querySelectorAll(".discount-item .bundle")
          .forEach((item) => {
            item.classList.remove("active");
          });

        document
          .querySelectorAll(".discount-item .standard")
          .forEach((item) => {
            item.classList.add("active");
          });
      }
    }
  });
});


// Update prices when color swatch is selected
document.addEventListener("change", function (event) {
  if (event.target.matches(".ColorSwatch__Radio")) {
    const selectedColor = event.target.value;

    const productVariants = window.__sunflow.product.variants;

    const colorVariants = productVariants.filter(
      (variant) => variant.option1 === selectedColor
    );

    colorVariants.forEach((variant) => {
      const itemElement = document.querySelector(
        `.bundle-select input[value="${variant.option2}"]`
      );

      if (itemElement) {
        const priceElement = itemElement
          .closest(".item")
          .querySelector("[data-standard-price], [data-bundle-price]");
        const comparePriceElement = itemElement
          .closest(".item")
          .querySelector(
            "[data-standard-compare-price], [data-bundle-compare-price]"
          );

        const formatPrice = (price) => {
          return price % 100 === 0
            ? `$${(price / 100).toFixed(0)}`
            : `$${(price / 100).toFixed(2)}`;
        };

        // Update the price elements
        if (priceElement) {
          priceElement.textContent = formatPrice(variant.price);
        }

        // Update the compare price element if compare_at_price > price
        if (
          comparePriceElement &&
          variant.compare_at_price &&
          variant.compare_at_price > variant.price
        ) {
          comparePriceElement.textContent = formatPrice(
            variant.compare_at_price
          );
        } else if (comparePriceElement) {
          comparePriceElement.textContent = ""; // Clear the compare price if none is set or if it's not greater than the price
        }
      }
    });
  }
});

// FAQ toggles
document.querySelectorAll('.Faq__Question').forEach( question => {
  question.addEventListener('click', (e)=> {
    e.currentTarget.closest('.Faq__Item').classList.toggle('open');
    toggle(e.currentTarget.nextElementSibling);
  });
});

// FAQ section links
document.querySelectorAll('a.FaqSummary__Link').forEach( link => {
  link.addEventListener('click', (e)=> {
    document.querySelectorAll('.FaqSummary__Item').forEach( item => {
      item.classList.remove('is-active');
    });
    e.currentTarget.parentNode.classList.add('is-active');
  });
});

// Show an element
var show = function(elem) {

  // Get the natural height of the element
  var getHeight = function () {
    elem.style.display = 'block'; // Make it visible
    var height = elem.scrollHeight + 'px'; // Get it's height
    elem.style.display = ''; //  Hide it again
    return height;
  };

  var height = getHeight(); // Get the natural height
  elem.classList.add('is-visible'); // Make the element visible
  elem.style.height = height; // Update the max-height

  // Once the transition is complete, remove the inline max-height so the content can scale responsively
  window.setTimeout(function () {
    elem.style.height = '';
  }, 350);

};

// Hide an element
var hide = function(elem) {

  // Give the element a height to change from
  elem.style.height = elem.scrollHeight + 'px';

  // Set the height back to 0
  window.setTimeout(function () {
    elem.style.height = '0';
  }, 1);

  // When the transition is complete, hide it
  window.setTimeout(function () {
    elem.classList.remove('is-visible');
  }, 350);

};

// Toggle element visibility
var toggle = function(elem, timing) {

  // Hide any open items
  document.querySelectorAll('.Faq__AnswerWrapper').forEach( answer => {
    if (answer.classList.contains('is-visible')) {
      answer.closest('.Faq__Item').classList.remove('open');
      hide(answer);
    }
  });

  // If the element is visible, hide it
  if (elem.classList.contains('is-visible')) {
    hide(elem);
    return;
  }

  // Otherwise, show it
  show(elem);

};
